<template>
	<div>
		<!-- 批量导入失败弹框 -->
		<el-dialog
			:title="title"
			:visible.sync="showDialog"
			center
			class="edit-dialog"
			:close-on-click-modal="false"
			@close="closeDialog"
		>
			<p class="tips">{{ failObj.msg }}</p>
			<p class="error-title">失败原因:</p>
			<el-card shadow="never">
				<ul class="error-list">
					<li
						class="error-item"
						v-for="(item, index) in failObj.failList"
						:key="index"
					>
						<span class="error-left">{{ item.value }}:</span>
						<span class="error-right">{{ item.label }}</span>
					</li>
				</ul>
			</el-card>

			<div slot="footer" class="dialog-footer">
				<el-button
					:loading="downloadLoading"
					type="primary"
					@click="exportFailData"
					>下载导入失败数据</el-button
				>
				<!-- <el-button @click="closeDialog"  type="primary">确认</el-button> -->
			</div>
		</el-dialog>
	</div>
</template>
 
<script>
	import { exportExcelInfo } from "@/assets/js/options.js";
	export default {
		name: "ImportFail",
		data() {
			return {
				showDialog: this.show,
				downloadLoading: false,
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			title: {
				type: String,
				default: "",
			},
			failObj: {
				type: Object,
				default: () => ({
					// 错误提示
					msg: "",
					// 错误数据列表
					failList: [
						{
							value: "ss",
							label: "ss",
						},
					],
					headerData: 0,
					failFullInfoList: [],
					fileName: "",
				}),
			},
		},
		computed: {},
		watch: {
			show(val) {
				this.showDialog = val;
			},
		},
		methods: {
			// 关闭弹框
			closeDialog() {
				this.showDialog = false;
				this.$emit("receive", {
					key: "showImportFail",
					value: this.showDialog,
				});
			},
			// 导出失败数据
			exportFailData() {
				this.downloadLoading = true;
				let headerData = exportExcelInfo[this.failObj.headerData] || [];
				let tHeader = [];
				let filterVal = [];
				headerData.forEach((item) => {
					tHeader.push(item.title);
					filterVal.push(item.key);
				});
				import("@/vendor/Export2Excel").then((excel) => {
					excel.export_json_to_excel({
						header: tHeader, //表头 必填
						data: this.formatJson(
							filterVal,
							this.failObj.failFullInfoList
						), //具体数据 必填
						filename: this.failObj.fileName, //非必填
						autoWidth: true, //非必填
						bookType: "xlsx", //非必填
					});
				});
				this.downloadLoading = false;
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map((v) => filterVal.map((j) => v[j]));
			},
		},
	};
</script>
 
<style scoped lang="scss">
	.tips {
		text-align: center;
		padding-bottom: 10px;
	}
	.error-title {
		font-weight: bold;
		margin: 10px 0;
	}
	.error-item {
		margin-bottom: 5px;
		.error-left {
			margin-right: 15px;
		}
	}
</style>